import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Endpoint } from '@/Config/api/endpoint';
import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import {
  DropdownMenuCheckboxItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from '@/Domain/components/Shared/DropdownMenu/DropdownMenu';
import { useConversationTranslation } from '@/Domain/hooks/Conversation/useConversationTranslate/useConversationTranslation.hook';

export const TranslationDropdown = () => {
  const { t } = useTranslation(['languages', 'inbox_v2']);
  const queryClient = useQueryClient();
  const params = useParams();

  const conversation = queryClient.getQueryData<ConversationDto>([
    Endpoint.conversation.get,
    params.id,
  ]);
  const currentLanguage = conversation?.most_frequent_language;

  const { language, handelChangeLanguage, DEFAULT_LANGUAGE_OPTION, LANGUAGES_OPTIONS } =
    useConversationTranslation({
      conversationId: params.id,
    });

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>{t('inbox_v2:setting_dropdown.translate_to')}</DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuCheckboxItem
          checked={!language}
          data-testid={`language-original`}
          onClick={() => handelChangeLanguage(DEFAULT_LANGUAGE_OPTION)}
        >
          {t('languages:original')}
        </DropdownMenuCheckboxItem>
        {LANGUAGES_OPTIONS.map(({ value, label }) => (
          <DropdownMenuCheckboxItem
            checked={!!(language && value.includes(language))}
            key={value}
            data-testid={`language-${value}`}
            disabled={currentLanguage ? value.includes(currentLanguage || '') : false}
            onClick={() => handelChangeLanguage(value)}
          >
            {label}
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
